import React, { useState, useEffect, useMemo } from "react";
import Input from "../Common/CustomInput";
import api from "../../setupMiddleware";
import useApiLoader from "../../Utils/useApiLoader";
import Loader from "../Loader/Loader";
import { getUser, hasPermission } from "../../Utils/auth";
import PlusIcon from "../../assets/icons/plus";
import Popup from "../Common/Popup";
import FileUpload from "../Common/FileUpload";
import { ToastContainer, toast, Bounce } from "react-toastify";
import {
  documentTypes,
  getFileType,
  createFormData,
} from "../../Utils/getUserUtitls";
import { FaFilePdf } from "react-icons/fa";
import { Link } from "react-router-dom";
import CustomSelect from "../Common/CustomSelect";
import moment from "moment/moment";
import PlaceholderImg from "../../assets/images/placeholder.jpg";
import { useNavigate } from "react-router-dom";
import Textarea from "../Common/Textarea";

const Profile = () => {
  const loading = useApiLoader();
  const prevMonthIndex = moment().month() - 1;
  const defaultMonthValue = prevMonthIndex >= 0 ? prevMonthIndex + 1 : 12;
  const [monthFilter, setMonthFilter] = useState(defaultMonthValue);
  const [yearFilter, setYearFilter] = useState(moment().year());
  // const [roleData, setRoleData] = useState([]);
  const [documentData, setDocumentData] = useState([]);
  const [generatedDocumentData, setGeneratedDocumentData] = useState([]);
  const [hrData, setHrData] = useState([]);
  const [managerData, setManagerData] = useState([]);
  // const [departmentData, setDepartmentData] = useState([]);
  // const [locationData, setLocationData] = useState([]);
  const [editOpen, setEditOpen] = useState(false);
  const [document, setDocument] = useState({
    document_type: "",
    file_path: [],
    other_name: "",
  });

  const [uploadOpen, setUploadOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("about");
  const [fieldErrors, setFieldErrors] = useState({});

  const userData = getUser();

  const documentOptions = documentTypes.filter((doc) =>
    doc.location_id.includes(userData?.location_id)
  );

  const { document_type, file_path, other_name } = document;

  const [employee, setEmployee] = useState();

  const [empData, setEmpData] = useState({
    phone: "",
    current_address: "",
  });

  const { phone, current_address } = empData;

  // ✅ Allowed years (2020 to current year)
  const currentYear = moment().year();
  const yearOptions = Array.from({ length: currentYear - 2020 + 1 }, (_, i) => {
    const year = 2020 + i;
    return { label: year.toString(), value: year };
  });

  // ✅ Months: show all months if past year, only till current month if current year
  const monthOptions = useMemo(() => {
    const months = moment.monthsShort(); // ["Jan", "Feb", ... "Dec"]

    if (yearFilter === currentYear) {
      const currentMonthIndex = moment().month(); // 0-based current month index
      // slice up to currentMonthIndex (excludes current month)
      return months.slice(0, currentMonthIndex).map((m, index) => ({
        label: m,
        value: index + 1, // month number (1-12)
      }));
    }

    return months.map((m, index) => ({
      label: m,
      value: index + 1, // month number (1-12)
    }));
  }, [yearFilter]);

  const getProfileInfo = async () => {
    await api.get(`/api/user/${userData?.id}`).then((res) => {
      if (res && res.status === 200) {
        setEmployee(res.data?.data);
        setEmpData({
          ...empData,
          phone: res.data?.data?.phone,
          current_address: res.data?.data?.current_address,
        });
      }
    });
  };

  const uploadDocument = async () => {
    const formData = new FormData();
    formData.append("user_id", userData?.id);
    formData.append("document_type", document_type);
    if (file_path && file_path.length > 0) {
      formData.append("file_path", file_path[0]);
    }
    try {
      await api.post(`/api/employee-documents`, formData).then((res) => {
        if (res && res.status === 201) {
          toast.success(res.data?.message, {
            position: "top-left",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            transition: Bounce,
          });
          // navigate("/employees");
        }
      });
    } catch (err) {
      if (err) {
        toast.error(err.message, {
          position: "top-left",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          transition: Bounce,
        });
      }
    }
  };

  console.log(documentData);
  const getAllDocuments = async () => {
    api
      .get(`/api/employee-documents/${userData?.id}`)
      .then((res) => {
        if (res && res.status === 200) {
          setDocumentData(res.data?.data);
        }
      })
      .catch((err) => {
        console.log(err.response.data.message);
      });
  };

  const getAllGeneratedDocuments = async () => {
    api
      .get(`/api/request-documents/approved`)
      .then((res) => {
        if (res && res.status === 200) {
          setGeneratedDocumentData(res.data?.data);
        }
      })
      .catch((err) => {
        console.log(err.response.data.message);
      });
  };

  const validateFields = () => {
    const newErrors = {};

    if (!phone) newErrors.phone = ["Phone is required"];
    if (!current_address)
      newErrors.current_address = ["Current Address is required"];

    setFieldErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const resetErrors = () => setFieldErrors({});

  const handleUpdateEmployee = async () => {
    resetErrors();

    // run frontend validation
    if (!validateFields()) {
      return; // stop if errors exist
    }
    try {
      const formData = createFormData(empData);
      console.log(formData);
      await api
        .post(`/api/update-employee/${userData?.id}`, formData)
        .then((res) => {
          if (res && res.status === 200) {
            toast.success(res.data?.message, {
              position: "top-left",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
              transition: Bounce,
            });
            setEditOpen(false);
            getProfileInfo();
          }
        });
    } catch (err) {
      if (err) {
        toast.error(err.message, {
          position: "top-left",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          transition: Bounce,
        });
      }
    }
  };

  // const getAllDepartments = async () => {
  //   api.get("/api/departments").then((res) => {
  //     if (res && res.status === 200) {
  //       setDepartmentData(res.data);
  //     }
  //   });
  // };

  const getPayslip = async () => {
    await api
      .post("/api/salaries/payslip", {
        month: monthFilter,
        year: yearFilter,
        user_id: userData.id,
      })
      .then((res) => {
        if (res && res.status === 200) {
          window.open(res.data?.payslip.file_path, "_blank");
        }
      })
      .catch((error) => {
        toast.error(error.response.data.message, {
          position: "top-left",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          transition: Bounce,
        });
      });
  };

  const getAllData = async () => {
    api.get("/api/master-data").then((res) => {
      if (res && res.status === 200) {
        const resData = res.data?.data;
        setHrData(resData?.hrs);
        setManagerData(resData?.managers);
      }
    });
  };

  const getManagerById = (id) => {
    const person = managerData.find((emp) => emp.id === id);
    return person ? `${person.first_name} ${person.last_name}` : "";
  };

  const getHrById = (id) => {
    const person = hrData.find((emp) => emp.id === id);
    return person ? `${person.first_name} ${person.last_name}` : "";
  };

  useEffect(() => {
    getProfileInfo();
    getAllDocuments();
    getAllGeneratedDocuments();
    getAllData();
    // getAllDepartments();
    // getAllLocation();
  }, []);

  const hasFile = Array.isArray(file_path) ? file_path.length > 0 : !!file_path; // works for string, null, undefined

  const hasDocumentType = !!document_type;
  const isOther = document_type === "Other";
  const hasOtherName = !!other_name;

  const isDisabled = !(
    (hasDocumentType && hasFile) ||
    (isOther && hasOtherName && hasFile)
  );
  return (
    <>
      {loading && <Loader opacity={90} fullscreen />}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center w-full mx-auto px-4 py-3 gap-4">
        {/* Left Content */}
        <p>
          <span className="block text-xl sm:text-2xl font-medium text-[#de2b26]">
            Profile
          </span>
          <span className="block text-sm text-[#142b70]/50">
            See and edit details
          </span>
        </p>

        {/* Right Button */}
        <div className="flex gap-4">
          <button
            onClick={() => setEditOpen(true)}
            className="flex items-center gap-2 px-4 py-2 rounded bg-[#de2b26] hover:bg-[#c30f0a] transition text-white text-sm font-medium"
          >
            Edit Details
          </button>
          {hasPermission("upload_employee_documents_upload") && (
            <button
              onClick={() => setUploadOpen(true)}
              className="flex items-center gap-2 px-4 py-2 rounded bg-[#de2b26] hover:bg-[#c30f0a] transition text-white text-sm font-medium"
            >
              <PlusIcon color="#fff" />
              Upload Documents
            </button>
          )}
          <Popup
            isOpen={uploadOpen}
            onClose={() => setUploadOpen(false)}
            title="Upload Document"
          >
            <div className="flex flex-col gap-6 mt-[30px]">
              <div className="flex flex-col gap-2">
                <div className="relative">
                  <FileUpload
                    label="Select Document"
                    accept=".jpg,.pdf,.doc,.docx"
                    multiple={false}
                    onChange={(file) =>
                      setDocument({ ...document, file_path: file })
                    }
                  />
                </div>
              </div>
              <div className="flex flex-col gap-2 mb-4">
                <p className="text-sm text-[#142b70]/80">Document Name</p>
                <div className="relative">
                  <CustomSelect
                    options={documentOptions}
                    placeholder="Document Name"
                    value={document_type}
                    width="w-full"
                    height="h-[46px]"
                    fontSize="14px"
                    onChange={(op) =>
                      setDocument({
                        ...document,
                        document_type: op.value,
                      })
                    }
                  />
                </div>
              </div>
              {document_type === "Other" && (
                <div className="flex flex-col gap-2 -mt-3 mb-4">
                  <p className="text-sm text-[#142b70]/80">
                    Other Document Name
                  </p>
                  <div className="relative">
                    <Input
                      placeholder="Other Document Name"
                      value={other_name}
                      width="w-full"
                      height="h-[46px]"
                      fontSize="14px"
                      onChange={(op) =>
                        setDocument({
                          ...document,
                          other_name: op.value,
                        })
                      }
                    />
                  </div>
                </div>
              )}
            </div>
            {/* Footer */}
            <div className="flex justify-end gap-4">
              <button
                onClick={() => setUploadOpen(false)}
                className="px-10 py-3.5 rounded-md border border-[#de2b26] text-[#de2b26] font-medium"
              >
                Cancel
              </button>
              <button
                onClick={uploadDocument}
                disabled={isDisabled}
                className="px-10 py-3.5 rounded-md bg-[#de2b26] text-white font-medium disabled:opacity-50"
              >
                Upload
              </button>
            </div>
          </Popup>
          {/* Edit Details */}
          <Popup
            isOpen={editOpen}
            onClose={() => setEditOpen(false)}
            title="Edit Your Details"
          >
            <div className="flex flex-col gap-6 mt-[30px]">
              <div className="flex flex-col gap-2">
                <p className="text-sm text-[#142b70]/80">Phone</p>
                <div className="relative">
                  <Input
                    type="number"
                    placeholder="Enter Phone Number"
                    value={phone}
                    onChange={(e) => {
                      setEmpData({
                        ...empData,
                        phone: `${e.target.value}`,
                      });
                      if (fieldErrors.phone) {
                        setFieldErrors({
                          ...fieldErrors,
                          phone: undefined,
                        });
                      }
                    }}
                    error={Boolean(fieldErrors.phone)}
                    helperText={fieldErrors?.phone?.[0]}
                  />
                </div>
              </div>
              <div className="flex flex-col gap-2 mb-4">
                <p className="text-sm text-[#142b70]/80">Current Address</p>
                <div className="relative">
                  <Textarea
                    value={current_address}
                    placeholder="Current Address"
                    onChange={(e) => {
                      setEmpData({
                        ...empData,
                        current_address: e.target.value,
                      });
                      if (fieldErrors.current_address) {
                        setFieldErrors({
                          ...fieldErrors,
                          current_address: undefined,
                        });
                      }
                    }}
                    error={Boolean(fieldErrors.current_address)}
                    helperText={fieldErrors?.current_address?.[0]}
                    rows={4}
                  />
                </div>
              </div>
            </div>
            {/* Footer */}
            <div className="flex justify-end gap-4">
              <button
                onClick={() => setEditOpen(false)}
                className="px-10 py-3.5 rounded-md border border-[#de2b26] text-[#de2b26] font-medium"
              >
                Cancel
              </button>
              <button
                onClick={handleUpdateEmployee}
                className="px-10 py-3.5 rounded-md bg-[#de2b26] text-white font-medium disabled:opacity-50"
              >
                Update
              </button>
            </div>
          </Popup>
        </div>
      </div>
      <div className="w-full mx-auto px-4 py-3 relative">
        <div className="bg-white border border-[#a48572]/20 rounded-3xl p-6 flex flex-col sm:flex-row gap-6 shadow-sm">
          {/* Avatar */}
          <div className="flex-shrink-0">
            <img
              src={employee?.employee_image || PlaceholderImg}
              alt={employee?.first_name + " " + employee?.last_name}
              className="w-48 h-48 rounded-2xl object-cover bg-[#de2b26]/20"
            />
          </div>

          {/* Info */}
          <div className="flex flex-col justify-between flex-1">
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center w-full mx-auto gap-4">
              <div>
                <h1 className="text-2xl font-semibold text-[#de2b26]">
                  {employee?.first_name} {employee?.last_name}
                </h1>
                <p className="text-sm text-[#142b70]/70">
                  {employee?.role?.name}
                </p>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-4 text-sm text-[#142b70]/80">
              {[
                { label: "Office Email", value: employee?.office_email },
                { label: "Phone", value: employee?.phone },
                { label: "Location", value: employee?.location?.name },
                { label: "Department", value: employee?.department?.name },
                { label: "Designation", value: employee?.designation?.title },
                { label: "Grade", value: employee?.grade?.title },
              ].map((item, idx) => (
                <div
                  key={idx}
                  className="flex items-start gap-2 rounded-lg p-3 pl-0"
                >
                  <div className="flex flex-col leading-tight">
                    <span className="text-[11px] uppercase tracking-wide text-[#142b70]/60 font-medium">
                      {item.label}
                    </span>
                    <span className="text-sm text-[#142b70] font-semibold">
                      {item.value || "—"}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="mt-6 border-b border-[#a48572]/20">
          <nav className="flex gap-6 text-sm">
            {[
              { id: "about", label: "About" },
              { id: "documents", label: "Documents" },
              { id: "payslip", label: "Salary Slips" },
            ].map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`pb-3 ${
                  activeTab === tab.id
                    ? "border-b-2 border-[#de2b26] text-[#142b70] font-medium"
                    : "text-[#142b70]/70 hover:text-[#142b70]"
                }`}
              >
                {tab.label}
              </button>
            ))}
          </nav>
        </div>
      </div>
      <div className="mt-6">
        {activeTab === "about" && (
          <div className="w-full mx-auto px-4 py-3 relative">
            <div className="bg-white border border-[#a48572]/10 rounded-2xl p-6">
              <p>
                <span className="block text-xl sm:text-2xl font-medium text-[#de2b26]">
                  About
                </span>
              </p>
              <hr />

              {/* Other info mapped automatically */}
              <div className="space-y-8 mt-8">
                {[
                  {
                    title: "Office Info",
                    items: [
                      { label: "Role", value: employee?.role?.name },
                      {
                        label: "Designation",
                        value: employee?.designation?.title,
                      },
                      { label: "Grade", value: employee?.grade?.title },
                      {
                        label: "Department",
                        value: employee?.department?.name,
                      },
                      ...(employee?.role_id === 3
                        ? [
                            {
                              label: "HR Head",
                              value: getHrById(employee?.hr_head),
                            },
                          ]
                        : employee?.role_id === 4
                        ? [
                            {
                              label: "Manager",
                              value: getManagerById(employee?.manager),
                            },
                          ]
                        : employee?.role_id === 8
                        ? [
                            {
                              label: "Team Leader",
                              value: employee?.team_leader,
                            },
                          ]
                        : []),
                      ...(employee?.role_id !== 3 ||
                      employee?.role_id !== 2 ||
                      employee?.role_id !== 1
                        ? [
                            {
                              label: "Hr",
                              value: getHrById(employee?.hr_id),
                            },
                          ]
                        : []),
                      {
                        label: "Job Location",
                        value: employee?.location?.name,
                      },
                    ],
                  },
                  {
                    title: "Personal Info",
                    items: [
                      { label: "Father Name", value: employee?.father_name },
                      { label: "Mother Name", value: employee?.mother_name },
                      { label: "Personal Email", value: employee?.email },
                      {
                        label: "Joining Date",
                        value: moment(employee?.joining_date).format(
                          "DD MMM, YYYY"
                        ),
                      },
                      {
                        label: "Emergency Contact",
                        value: employee?.emergency_contact,
                      },
                      {
                        label: "Date of Birth",
                        value: moment(employee?.dob).format("DD MMM, YYYY"),
                      },
                      { label: "Gender", value: employee?.gender },
                      {
                        label: "Marital Status",
                        value: employee?.marital_status,
                      },
                      {
                        label: "Place of Birth",
                        value: employee?.place_of_birth,
                      },
                      {
                        label: "Nationality",
                        value: employee?.nationality,
                      },
                      {
                        label: "Employee Personal Number",
                        value: employee?.employee_personal_number,
                      },
                      {
                        label: "Bank Account Number",
                        value: employee?.bank_account_number,
                      },
                      {
                        label: "Bank Routing Code",
                        value: employee?.bank_routing_code,
                      },
                      ...(employee?.location_id === 1
                        ? [
                            {
                              label: "Emirates Id",
                              value: employee?.emirate_id,
                            },
                          ]
                        : []),
                      {
                        label: "Passport Number",
                        value: employee?.passport_no,
                      },
                      {
                        label: "Permanent Address",
                        value: employee?.permanent_address,
                      },
                      {
                        label: "Current Address",
                        value: employee?.current_address,
                      },
                    ],
                  },
                ].map((group, gIdx) => (
                  <div key={gIdx}>
                    {/* Section title */}
                    <h3 className="text-lg font-bold text-[#142b70] mb-4 pb-1">
                      {group.title}
                    </h3>

                    {/* Cards grid */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                      {group.items.map((item, idx) => (
                        <div
                          key={idx}
                          className="flex items-start gap-2 bg-[#de2b26]/5 border-l-2 border-[#de2b26] rounded-lg p-3"
                        >
                          <div className="flex flex-col leading-tight">
                            <span className="text-[11px] uppercase tracking-wide text-[#142b70]/60 font-medium">
                              {item.label}
                            </span>
                            <span className="text-sm text-[#142b70] font-semibold">
                              {item.value || "—"}
                            </span>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {activeTab === "documents" && (
          <div className="w-full mx-auto px-4 py-3 relative">
            <div className="bg-white border border-[#a48572]/10 rounded-2xl p-6">
              <p>
                <span className="block text-xl sm:text-2xl font-medium text-[#de2b26]">
                  Documents
                </span>
              </p>
              <hr />
              <div className="flex gap-6 my-10">
                <div className="border-2 border-[#a48572]/10 rounded-2xl p-4 w-full max-w-96">
                  <p>
                    <span className="block text-xl sm:text-sm font-medium text-[#142b70]">
                      Uploaded Documents
                    </span>
                  </p>
                  <div className="flex items-center flex-col gap-2 mt-4 w-full">
                    {documentData.length > 0 ? (
                      documentData.map((doc) => (
                        <Link
                          to={doc.file_path}
                          target="_blank"
                          className="flex justify-start items-center gap-2 border-2 border-[#a48572]/10 rounded-2xl p-4 w-full"
                        >
                          <div>
                            {(getFileType(doc.file_path) === "jpeg" ||
                              getFileType(doc.file_path) === "jpg" ||
                              getFileType(doc.file_path) === "png") && (
                              <img
                                src={doc.file_path}
                                alt={doc.document_type}
                                className="w-10 h-10 rounded-xl object-cover"
                              />
                            )}
                            {getFileType(doc.file_path) === "pdf" && (
                              <FaFilePdf className="text-[#c30f0a] text-2xl w-10" />
                            )}
                          </div>
                          <div>{doc.document_type}</div>
                        </Link>
                      ))
                    ) : (
                      <div className="text-[12px] text-[#c30f0a] text-left w-full">
                        No Document found.
                      </div>
                    )}
                  </div>
                </div>
                <div className="border-2 border-[#a48572]/10 rounded-2xl p-4 w-full max-w-96">
                  <p>
                    <span className="block text-xl sm:text-sm font-medium text-[#142b70]">
                      Generated Documents
                    </span>
                  </p>
                  <div className="flex items-center flex-col gap-2 mt-4 w-full">
                    {generatedDocumentData.length > 0 ? (
                      generatedDocumentData.map((doc) => (
                        <Link
                          to={doc.file_path}
                          target="_blank"
                          className="flex justify-start items-center gap-2 border-2 border-[#a48572]/10 rounded-2xl p-4 w-full"
                        >
                          <div>
                            {(getFileType(doc.file_path) === "jpeg" ||
                              getFileType(doc.file_path) === "jpg" ||
                              getFileType(doc.file_path) === "png") && (
                              <img
                                src={doc.file_path}
                                alt={doc.document_type}
                                className="w-10 h-10 rounded-xl object-cover"
                              />
                            )}
                            {getFileType(doc.file_path) === "pdf" && (
                              <FaFilePdf className="text-[#c30f0a] text-2xl w-10" />
                            )}
                          </div>
                          <div>
                            {doc.document_type === "salary_transfer"
                              ? "Salary Transfer"
                              : doc.document_type === "noc"
                              ? "NOC"
                              : "N/A"}
                          </div>
                        </Link>
                      ))
                    ) : (
                      <div className="text-[12px] text-[#c30f0a] text-left w-full">
                        No Document found.
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {activeTab === "payslip" && (
          <div className="w-full mx-auto px-4 py-3 relative">
            <div className="bg-white border border-[#a48572]/10 rounded-2xl p-6">
              <p>
                <span className="block text-xl sm:text-2xl font-medium text-[#de2b26]">
                  Salary Slip
                </span>
              </p>
              <hr />
              <div className="my-8 py-8 max-w-2xl m-auto">
                <div className="flex justify-between gap-5">
                  <div className="flex flex-col gap-2 w-full">
                    <p className="text-sm text-[#142b70]/80">Month</p>
                    <CustomSelect
                      options={monthOptions}
                      placeholder="Month"
                      value={monthFilter}
                      onChange={(opt) => setMonthFilter(opt.value)}
                      width="w-full"
                      height="h-[46px]"
                      fontSize="14px"
                      optionFontSize="sm"
                    />
                  </div>
                  <div className="flex flex-col gap-2 w-full">
                    <p className="text-sm text-[#142b70]/80">Year</p>
                    <CustomSelect
                      options={yearOptions}
                      placeholder="Year"
                      value={yearFilter}
                      onChange={(opt) => setYearFilter(opt.value)}
                      width="w-full"
                      height="h-[46px]"
                      fontSize="14px"
                      optionFontSize="sm"
                    />
                  </div>
                </div>
                {/* Footer */}
                <div className="flex justify-center gap-4 mt-6">
                  <button
                    onClick={getPayslip}
                    className="px-10 py-3.5 rounded-md border border-[#de2b26] bg-[#de2b26] text-white font-medium"
                  >
                    Download Salary Slip
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <ToastContainer />
    </>
  );
};

export default Profile;
